import React from 'react';
import { useBlocker } from 'react-router-dom';
import { Prompt } from '../components/Prompt';

export function BlockNavigationPrompt() {
	const block = useBlocker(true);

	return block.state === 'blocked' ? (
		<Prompt
			intent="alert"
			title="Unsaved changes"
			text="Are you sure you want to leave this page? You have unsaved changes that will be lost."
			onAction={block.proceed}
			onCancel={block.reset}
			actionLabel="Leave"
			cancelLabel="Stay"
		/>
	) : null;
}
